module.exports = __webpack_public_path__ + "static/media/keyboard-alt-1-svgrepo-com.77f260f5.svg";